angular.module('rjmNg.directives').directive "facebookProfilePicker", [
  () ->
    bindToController: true
    controllerAs: "view"
    require: "^?rjmUi"
    restrict: "E"
    scope:
      cancelCallback: "&"
      connection: "="
      successCallback: "&"
    templateUrl: "directive.facebookProfilePicker.html"
    controller: [
      "InputConnections"
      "app"
      "notification"
      (
        InputConnections
        app
        notification
      ) ->

        view = @
        view.loading = false

        view.accountId = null

        view.profiles = null

        InputConnectionsInstance = InputConnections(app.getClientId())

        view.NOTIFICATION_SCOPE = "global"
        notification.clear(view.NOTIFICATION_SCOPE)

        lastSelectedAdAccount = null

        ERROR_MESSAGES =
          NO_DATA: "None of the Facebook Ad accounts associated with the
            credentials you've supplied contain data that Adobe Commerce Intelligence can access.
            Please make sure that the credentials you've supplied have
            appropriate access."
          PROFILES: "An error occurred fetching a list of Facebook Ad accounts
            with data to track."
          PROFILE_NO_DATA: "We were unable to verify that Adobe Commerce Intelligence can access
            data in this integration using the credentials you have provided.
            If you are certain the integration has data that Adobe Commerce Intelligence will be
            able to query using the supplied credentails, you may save the integration anyway."

        showError = (message) ->
          view.loading = false
          notification.clear(view.NOTIFICATION_SCOPE)
          notification.error("Something went wrong.", message, view.NOTIFICATION_SCOPE)

        showWarning = (message) ->
          view.loading = false
          notification.clear(view.NOTIFICATION_SCOPE)
          notification.warning("", message, view.NOTIFICATION_SCOPE)

        view.changeSelectedProfile = ({account_id}) ->
          view.accountId = account_id

        view.cancel = () ->
          view.cancelCallback()

        finishSelectingProfile = () ->
          view.connection.properties.account_id = view.accountId
          view.successCallback()

        view.selectProfile = () ->
          if view.accountId is lastSelectedAdAccount
            finishSelectingProfile()
            return

          profile = _.find view.profiles, (profile) ->
            profile.account_id is view.accountId

          if not profile.saw_data
            lastSelectedAdAccount = profile.account_id
            showWarning ERROR_MESSAGES.PROFILE_NO_DATA
          else
            finishSelectingProfile()

        @$onInit = () ->
          view.accountId = view.connection.properties.account_id

          view.loading = true
          InputConnectionsInstance.getProfiles(view.connection.id, view.connection.type)
          .then (profiles) ->
            if profiles.length > 0
              view.profiles = profiles

              # If the profile isn't set, set it to the first profile.
              unless view.accountId?
                firstProfile = profiles[0]
                view.accountId = firstProfile.account_id

              notification.clear(view.NOTIFICATION_SCOPE)

            else
              showError ERROR_MESSAGES.NO_DATA
          .catch () ->
            showError ERROR_MESSAGES.PROFILES
          .finally () ->
            view.loading = false

        view
    ]
    link: (scope, element, attributes, rjmUi) ->
      if rjmUi?
        scope.$watch "view.loading", () ->
          rjmUi.blockUi("facebook-profile-picker", scope.view.loading)

]
